import React, { useEffect, useState, useMemo } from "react";
import moment from "moment";
import Container from "@material-ui/core/Container";
import { Button, Grid, Tooltip } from "@material-ui/core";
import ColAtm from "../../../../atomic/Col/Col";
import BlockAtm from "../../../../atomic/Block/Block";
import LabelAtm from "../../../../atomic/Label/Label";
import ButtonAtm from "../../../../atomic/Button/Button";
import InventorySkeleton from "../../../../molecules/InventorySkeleton/InventorySkeleton";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import UpdateOrCreateCompetitorModal from "./UpdateOrCreateCompetitorAnalysisModal";
import { getAppLang, getCurrency, getProperty, isDefined } from "../../../../../utils";
import { DOWNLOAD_CPA_EXCEL } from "../../../../../constants/api.constants";
import axios from "axios";
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { getCpaDailyPrice } from "../../../../../redux/actions/Network/Inventory/CompetitorActions";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CompetitorFilter from "../CompetitorFilter";
import { BEST_AVAILABLE_PRICE, AI_COMPETITOR_ANALYSIS } from "../../../../../constants/api.constants";
import Divider from "@material-ui/core/Divider";
import { Chart as ChartJS, CategoryScale, LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Legend,
} from "chart.js";
import { Line } from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Legend
);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

const CompetitorAnalysis = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const classes = useStyles();

    const { getCpa, fetching } = useSelector(props => props?.cpaReducer);
    
    const filteredCpa = useMemo(() => {
            if (!getCpa || !Array.isArray(getCpa)) return [];
            return getCpa.filter(c => c?.competitor_property_source !== "extranetwork");
        }, [getCpa]);
    
    // const { loading, error } = useSelector((state) => state.cpaReducer);
    const { prices, loading, error } = useSelector((state) => state.cpaReducer);

    const lsAllDays = JSON.parse(localStorage.getItem("allDays"));

    const [modalOpen, setModalOpen] = useState(false);
    const [modalList, setModalList] = useState([]);
    const [modalProvider, setModalProvider] = useState('');
    const [modalAmount, setModalAmount] = useState('');
    const [modalCurrency, setModalCurrency] = useState('');
    // const [selectedProvider, setSelectedProvider] = useState("");
    const selectedProvider = props.selectedProvider || "";
    const [excelUrl, setExcelUrl] = useState("");
    const [disableExcelBtn, setDisableExcelBtn] = useState(false);
    const [allProviders, setAllProviders] = useState([]);
    const [openedHotelKey, setOpenedHotelKey] = useState(null);
    const [subProviders, setSubProviders] = useState('');
    // const [changeView, setChangeView] = useState(false);
    const currency = props?.currency;

    const [currentPropertyPrices, setCurrentPropertyPrices] = useState(props?.currentPropertyPrices);
    const [currentPropertyInfo, setCurrentPropertyInfo] = useState(props?.currentPropertyInfo);
    const [getBestAvailableRate, setGetBestAvailableRate] = useState(localStorage.getItem("getBestAvailableRate") === "true");

    useEffect(() => {
        setCurrentPropertyInfo(props.currentPropertyInfo)
    }, [props.currentPropertyInfo]);

    useEffect(() => {
        setCurrentPropertyPrices(props.currentPropertyPrices)
    }, [props.currentPropertyPrices]);

    const getUserProperty = () => {
        const params = {
            params: {
                property_id: getProperty(),
                type : "range",
                start_date: lsAllDays[0],
                finish_date: lsAllDays[lsAllDays.length - 1],
            }
        };
        axios.post(BEST_AVAILABLE_PRICE, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            const data = result.data.data;
            // Otel bilgisi
            setCurrentPropertyInfo({
                name: props?.propertyName,
                key: "property-" + getProperty(), 
                currency: data.currency,
            });

            const hasData = data && typeof data === "object" && !Array.isArray(data) && data.date && Object.keys(data.date).length > 0;
            const pricesObj = {};
            if (hasData) {
                Object.entries(data.date).forEach(([date, obj]) => {
                    pricesObj[`${"property-"}${getProperty()}_${date}`] = {
                        amount: obj.rate,
                        currency: data.currency,
                        provider: "",
                    };
                });
            }
            setCurrentPropertyPrices(pricesObj);
            setGetBestAvailableRate(true);
            localStorage.setItem("getBestAvailableRate", "true");
        }).catch(function (error) {
            console.log(error);
            setGetBestAvailableRate(false);
            localStorage.setItem("getBestAvailableRate", "false");
        });
    }

    useEffect(() => {
        if (props.getBestAvailableRate) {
            props.getBestAvailableRate(getBestAvailableRate);
        }
    }, [getBestAvailableRate]);
    
    const downloadExcel = () => {
        const url = DOWNLOAD_CPA_EXCEL;

        if (excelUrl === "") {
            setDisableExcelBtn(true)
        }

        const data = ({
            params: {
                property_id: getProperty(),
                start_date: lsAllDays[0],
                finish_date: lsAllDays[lsAllDays.length - 1],
                currency: currency ?? getCurrency()
            }
        });
        axios.post(url, data, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setExcelUrl(result.data.data.url)
            setDisableExcelBtn(false)
        }).catch(function (error) {
            console.log(error);
        });
    }

    useEffect(() => {
        if (excelUrl !== "") {
            window.open(excelUrl)
        }
        setExcelUrl("")
        setDisableExcelBtn(false)
    }, [excelUrl])

    useEffect(() => {
        if (props.trigger) {
            lsAllDays.map((date) => {
                filteredCpa.map((hotel) => {
                    dispatch(getCpaDailyPrice(date, hotel.key, currency));
                });
            });
            getUserProperty();
        }
    }, [props.trigger]);

    useEffect(() => {
        if (props.downloadExcel) {
            downloadExcel();
        }
    }, [props.downloadExcel]);

    const openModal = (e, key, selectedSubProvider) => {
        e.stopPropagation();
        const priceObj = prices[key];
        if (!priceObj) return;

        const provider = priceObj.provider;
        const amount = priceObj.amount;
        const currency = priceObj.currency;

        // provider başta olacak şekilde sıralama
        let sortedList = [];
        if (Array.isArray(priceObj.all)) {
            sortedList = [
                ...priceObj.all.filter(item => item.provider === provider),
                ...priceObj.all.filter(item => item.provider !== provider)
            ];
        }

        setModalProvider(provider);
        setModalAmount(amount);
        setModalCurrency(currency);
        setModalList(sortedList);
        setModalOpen(true);
        if (selectedSubProvider) {
            setSubProviders(selectedSubProvider);
        } else {
            setSubProviders('');
        }
    };

    // const allProviders = Array.from(new Set(
    //     Object.values(prices)
    //         .flatMap(p => (p.all || []).map(x => x.provider && x.provider.trim().toLowerCase()))
    //         .filter(Boolean)
    // ));

    useEffect(() => {
        const providers = Array.from(new Set(
            Object.values(prices)
                .flatMap(p => (p.all || []).map(x => x.provider && x.provider.trim().toLowerCase()))
                .filter(Boolean)
        ));
        setAllProviders(providers);

        if (props.onProvidersChange) {
            props.onProvidersChange(providers);
        }
        // if (props.onDataLoaded) {
        //     props.onDataLoaded();
        // }
    }, [prices]);

    const filteredModalList = selectedProvider
        // ? modalList.filter(item => item.provider && item.provider.trim().toLowerCase() === selectedProvider)
        ? modalList.filter(item => item.provider)
        : modalList;

    function formatAmountWithDot(amount) {
        if (typeof amount === "number" || (typeof amount === "string" && !isNaN(amount))) {
            const parts = amount.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(".");
        }
        return amount;
    }

    // const onChangeView = (e) => {
    //     setChangeView(!changeView);
    // }

    // Grafik Görünümü (Area Chart)
    const getChartData = () => {
        // X ekseni: Tarihler
        // Y ekseni: Fiyatlar
        const labels = lsAllDays.map(date => moment(date).format('DD MMM'));

        const colorList = [
            'rgba(25, 118, 210, 0.7)',
            'rgba(220, 38, 38, 0.7)',
            'rgba(34, 197, 94, 0.7)',
            'rgba(234, 179, 8, 0.7)',
            'rgba(168, 85, 247, 0.7)',
            'rgba(59, 130, 246, 0.7)',
            'rgba(217, 255, 0, 0.7)',
            'rgba(16, 185, 129, 0.7)',
            'rgba(239, 68, 68, 0.7)',
            'rgba(99, 102, 241, 0.7)',
        ];

        const myHotelColorIdx = filteredCpa?.length ? filteredCpa.length % colorList.length : 0;
        const myHotelBorderColor = colorList[6];
        const myHotelBackgroundColor = myHotelBorderColor.replace('0.7', '0.1');

        const myHotelDataset = currentPropertyInfo ? {
            label: currentPropertyInfo.name,
            data: lsAllDays.map(date => {
                const key = `${currentPropertyInfo.key}_${date}`;
                const priceObj = currentPropertyPrices[key];
                return (priceObj && typeof priceObj.amount === 'number') ? priceObj.amount : null;
            }),
            borderColor: myHotelBorderColor,
            tension: 0.4,
            pointHoverBackgroundColor: myHotelBorderColor,
            pointHoverBorderColor: myHotelBorderColor,
            pointRadius: 10,
            pointHoverRadius: 10,
        } : null;

        const datasets = [
            ...(myHotelDataset ? [myHotelDataset] : []),
            ...(filteredCpa || []).map((hotel, hotelIdx) => {
                const data = lsAllDays.map(date => {
                    const key = `${hotel.key}_${date}`;
                    const priceObj = prices[key];

                    if (selectedProvider) {
                        if (priceObj?.provider && priceObj.provider.trim().toLowerCase() === selectedProvider) {
                            return typeof priceObj.amount === 'number' ? priceObj.amount : null;
                        }
                        if (Array.isArray(priceObj?.all)) {
                            const found = priceObj.all.find(
                                item => item.provider && item.provider.trim().toLowerCase() === selectedProvider
                            );
                            return typeof found?.amount === 'number' ? found.amount : null;
                        }
                        return null;
                    }

                    if (Array.isArray(priceObj?.all)) {
                        const firstProvider = priceObj.all[0];
                        return typeof firstProvider?.amount === 'number' ? firstProvider.amount : null;
                    } else if (typeof priceObj?.amount === 'number') {
                        return priceObj.amount;
                    }
                    return null;
                });
                const borderColor = colorList[hotelIdx % colorList.length];
                const backgroundColor = borderColor.replace('0.7', '0.1');
                return {
                    label: hotel.name,
                    data,
                    borderColor,
                    tension: 0.4,
                    pointHoverBackgroundColor: borderColor,
                    pointHoverBorderColor: borderColor,
                    pointRadius: 10,
                    pointHoverRadius: 10,
                };
            })
        ];

        return {
            labels,
            datasets,
        };
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top', fullSize: true },
            title: { display: false },
            tooltip: {
                position: 'nearest',
                callbacks: {
                    beforeLabel: function(context) {
                        return context.dataset.label || '';
                    },
                    label: function(context) {
                        const dateIdx = context.dataIndex;
                        const date = lsAllDays[dateIdx];
                        let amount = context.parsed.y;
                        let providerName = '';
                        let currencyLabel = currency ?? getCurrency();

                        // Kendi otelinin dataseti
                        if (context.dataset.label === currentPropertyInfo?.name) {
                            const key = `${currentPropertyInfo.key}_${date}`;
                            const priceObj = currentPropertyPrices[key];
                            amount = priceObj?.amount ?? '-';
                            providerName = " ";
                            currencyLabel = priceObj?.currency ?? currencyLabel;
                        } else {
                            const hotelIdx = context.datasetIndex - (currentPropertyInfo ? 1 : 0);
                            const hotel = (filteredCpa || [])[hotelIdx];
                            if (hotel && prices) {
                                const key = `${hotel.key}_${date}`;
                                const priceObj = prices[key];
                                if (selectedProvider) {
                                    if (priceObj?.provider && priceObj.provider.trim().toLowerCase() === selectedProvider) {
                                        providerName = priceObj.provider;
                                        amount = priceObj.amount;
                                    }
                                    else if (Array.isArray(priceObj?.all)) {
                                        const found = priceObj.all.find(
                                            item => item.provider && item.provider.trim().toLowerCase() === selectedProvider
                                        );
                                        if (found) {
                                            providerName = found.provider;
                                            amount = found.amount;
                                        } else {
                                            return null;
                                        }
                                    } else {
                                        return null;
                                    }
                                } else {
                                    if (Array.isArray(priceObj?.all) && priceObj.all[0]?.provider) {
                                        providerName = priceObj.all[0].provider;
                                    } else if (priceObj?.provider) {
                                        providerName = priceObj.provider;
                                    }
                                }
                                currencyLabel = priceObj?.currency ?? currencyLabel;
                            }
                        }
                        if (!providerName) return null;
                        const displayAmount = (amount === undefined || amount === null) ? '-' : amount;
                        return `${providerName}: ${displayAmount} ${currencyLabel}`;
                    }
                }
            }
        },
        interaction: {
            mode: 'nearest',
            intersect: false
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: { callback: value => value }
            }
        }
    };
    
    const hotelAmounts = [
        ...(currentPropertyInfo ? [{
            name: currentPropertyInfo.name,
            total: (() => {
                let total = 0;
                let count = 0;
                lsAllDays.forEach(date => {
                    const key = `${currentPropertyInfo.key}_${date}`;
                    const priceObj = currentPropertyPrices[key];
                    if (!priceObj || priceObj.amount === null || priceObj.amount === undefined) return;
                    total += priceObj.amount;
                    count += 1;
                });
                return count > 0 ? +(total / count).toFixed(0) : 0;
            })()
        }] : []),

        ...(filteredCpa || []).map((hotel) => {
            let total = 0;
            let count = 0;
            lsAllDays.forEach(date => {
                const key = `${hotel.key}_${date}`;
                const priceObj = prices[key];
                if (!priceObj || priceObj.amount === null || priceObj.amount === undefined) return;
                total += priceObj.amount;
                count += 1;
            });
            const average = count > 0 ? +(total / count).toFixed(0) : 0;
            return {
                name: hotel?.name,
                total: average
            };
        })
    ].sort((a, b) => {
        if (!a.total && b.total) return 1;
        if (a.total && !b.total) return -1;
        if (!a.total && !b.total) return 0;
        return a.total - b.total;
    });

    return (
        <>
            {
                fetching ?
                    <InventorySkeleton />
                    :
                    <>
                        {
                            filteredCpa.length > 0 ?
                                <>
                                
                                {window.innerWidth < 768 && (
                                <>
                                    {currentPropertyInfo &&
                                        <div key={currentPropertyInfo?.key} className="mobile-competitor-hotel-card">
                                            <div className="mobile-competitor-hotel-header">
                                                <i className="gray fas fa-hotel" />
                                                <span className="mobile-competitor-hotel-name">{currentPropertyInfo?.name}</span>
                                            </div>
                                            <div className="mobile-competitor-prices-list">
                                                {lsAllDays.map((date) => {
                                                    const key = `${currentPropertyInfo.key}_${date}`;
                                                    const priceObj = currentPropertyPrices[key];
                                                    const isWeekend = [5, 6].includes(moment(date).locale('de').weekday());
                                                    let displayAmount = "-";
                                                    if (priceObj) {
                                                        displayAmount = priceObj?.amount === 0 ? "-" : priceObj?.amount;
                                                    }

                                                    const competitorPricesForDay = (filteredCpa || [])
                                                        .map(hotel => {
                                                            const hotelKey = `${hotel.key}_${date}`;
                                                            const hotelPriceObj = prices[hotelKey];
                                                            
                                                            if (!hotelPriceObj) return null;
                                                            
                                                            if (selectedProvider) {
                                                                if (hotelPriceObj.provider && hotelPriceObj.provider.trim().toLowerCase() === selectedProvider.toLowerCase()) {
                                                                    return hotelPriceObj.amount;
                                                                }
                                                                if (Array.isArray(hotelPriceObj.all)) {
                                                                    const found = hotelPriceObj.all.find(
                                                                        item => item.provider && item.provider.trim().toLowerCase() === selectedProvider.toLowerCase()
                                                                    );
                                                                    if (found && typeof found.amount === 'number') {
                                                                        return found.amount;
                                                                    }
                                                                }
                                                                return null;
                                                            }
                                                            
                                                            return hotelPriceObj.amount;
                                                        })
                                                        .filter(p => typeof p === 'number' && !isNaN(p) && p > 0);

                                                    const avgCompetitorPrice = competitorPricesForDay.length > 0
                                                        ? competitorPricesForDay.reduce((a, b) => a + b, 0) / competitorPricesForDay.length
                                                        : null;

                                                    let percentDiff = null;
                                                    if (
                                                        priceObj &&
                                                        typeof priceObj.amount === 'number' &&
                                                        priceObj.amount > 0 &&
                                                        avgCompetitorPrice !== null &&
                                                        avgCompetitorPrice > 0
                                                    ) {
                                                        percentDiff = ((priceObj.amount - avgCompetitorPrice) / avgCompetitorPrice) * 100;
                                                    }
                                                    const isZero = Math.abs(percentDiff) < 0.5;
                                                    
                                                    return (
                                                        <div
                                                            className={`mobile-competitor-price-card${isWeekend ? " weekend-inputs" : ""}`}
                                                            key={key}
                                                            style={{ position: 'relative' }}
                                                        >
                                                            <div className="mobile-competitor-date">
                                                                {moment(date).format('DD MMM ddd')}
                                                            </div>
                                                            <div className="mobile-competitor-amount">
                                                                <span style={{height: "auto", width: "auto"}}>{displayAmount} {priceObj?.currency ?? currency ?? getCurrency()}</span>
                                                                {percentDiff !== null && !isNaN(percentDiff) && (
                                                                    <span
                                                                        style={{
                                                                            display: 'block',
                                                                            fontSize: '11px',
                                                                            fontWeight: 500,
                                                                            color: isZero ? '#757575' : (percentDiff > 0 ? '#388e3c' : '#d32f2f'),
                                                                            marginTop: 2,
                                                                            lineHeight: 1,
                                                                            textAlign: 'center'
                                                                        }}
                                                                    >
                                                                        {Math.abs(percentDiff).toFixed(0)}%
                                                                        {!isZero && (percentDiff > 0 ? '↑' : '↓')}
                                                                    </span>
                                                                )}
                                                                {avgCompetitorPrice !== null && (
                                                                <span
                                                                    style={{
                                                                        display: 'block',
                                                                        fontSize: '11px',
                                                                        fontWeight: 400,
                                                                        color: '#888',
                                                                        marginTop: 6,
                                                                        lineHeight: 1,
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                   {formatAmountWithDot(Number(avgCompetitorPrice.toFixed(1)))}
                                                                </span>
                                                            )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    }
                                    {filteredCpa?.map((hotel) =>
                                        <div key={hotel.key} className="mobile-competitor-hotel-card">
                                            <div className="mobile-competitor-hotel-header">
                                                <i className="gray fas fa-hotel" />
                                                <span className="mobile-competitor-hotel-name">{hotel?.name}</span>
                                            </div>
                                            <div className="mobile-competitor-prices-list">
                                                {lsAllDays.map((date) => {
                                                    const key = `${hotel.key}_${date}`;
                                                    const priceObj = prices[key];
                                                    const isWeekend = [5, 6].includes(moment(date).locale('de').weekday());
                                                    const selected = selectedProvider;
                                                    let showPrice = false;
                                                    let displayAmount = "-";
                                                    let displayProvider = "-";

                                                    if (!selected) {
                                                        showPrice = true;
                                                        if (priceObj) {
                                                            displayAmount = priceObj.amount ?? "-";
                                                            displayProvider = priceObj.provider ?? "-";
                                                        }
                                                    } else if (priceObj) {
                                                        if (priceObj.provider && priceObj.provider.trim().toLowerCase() === selected) {
                                                            showPrice = true;
                                                            displayAmount = priceObj.amount ?? "-";
                                                            displayProvider = priceObj.provider ?? "-";
                                                        } else if (Array.isArray(priceObj.all)) {
                                                            const found = priceObj.all.find(
                                                                item => item.provider && item.provider.trim().toLowerCase() === selected
                                                            );
                                                            if (found) {
                                                                showPrice = true;
                                                                displayAmount = found.amount ?? "-";
                                                                displayProvider = found.provider ?? "-";
                                                            }
                                                        }
                                                    }

                                                    // Diğer rakip otellerin aynı gün fiyatları (kendi otel hariç)
                                                    const allOtherPrices = [];
                                                    (filteredCpa || []).forEach(otherHotel => {
                                                        if (otherHotel.key !== hotel.key) {
                                                            const otherKey = `${otherHotel.key}_${date}`;
                                                            const otherPrice = prices[otherKey]?.amount;
                                                            if (typeof otherPrice === 'number' && !isNaN(otherPrice) && otherPrice > 0) {
                                                                allOtherPrices.push(otherPrice);
                                                            }
                                                        }
                                                    });
                                                    const avgOtherPrice = allOtherPrices.length > 0
                                                        ? allOtherPrices.reduce((a, b) => a + b, 0) / allOtherPrices.length
                                                        : null;

                                                    let percentDiff = null;
                                                    const currentAmount = typeof displayAmount === 'number' ? displayAmount : null;
                                                    if (
                                                        currentAmount !== null &&
                                                        currentAmount > 0 &&
                                                        avgOtherPrice !== null &&
                                                        avgOtherPrice > 0
                                                    ) {
                                                        percentDiff = ((currentAmount - avgOtherPrice) / avgOtherPrice) * 100;
                                                    }
                                                    const isZero = Math.abs(percentDiff) < 0.5;

                                                    return (
                                                        <div
                                                            className={`mobile-competitor-price-card${isWeekend ? " weekend-inputs" : ""}`}
                                                            key={key}
                                                            style={{ cursor: showPrice ? 'pointer' : 'default', position: 'relative' }}
                                                            onClick={showPrice && !loading[key] && !error[key] ? (e) => openModal(e, key) : undefined}
                                                        >
                                                            <div className="mobile-competitor-date">
                                                                {moment(date).format('DD MMM ddd')}
                                                            </div>
                                                            <div className="mobile-competitor-amount">
                                                                {loading[key] ? (
                                                                    <CircularProgress
                                                                        className='circularProgress-report-mobile'
                                                                        style={{
                                                                            color: "#d71f26",
                                                                            zIndex: "99"
                                                                        }}
                                                                        size={16}
                                                                    />
                                                                ) : error[key] ? (
                                                                    <span style={{height: "auto", width: "auto"}}>-</span>
                                                                ) : showPrice ? (
                                                                    <>
                                                                        <span style={{height: "auto", width: "auto"}}>{displayAmount} {currency ?? getCurrency()}</span>
                                                                        {percentDiff !== null && !isNaN(percentDiff) && (
                                                                            <span
                                                                                style={{
                                                                                    display: 'block',
                                                                                    fontSize: '11px',
                                                                                    fontWeight: 500,
                                                                                    color: isZero ? '#757575' : (percentDiff > 0 ? '#388e3c' : '#d32f2f'),
                                                                                    marginTop: 2,
                                                                                    lineHeight: 1,
                                                                                    textAlign: 'center'
                                                                                }}
                                                                            >
                                                                                {Math.abs(percentDiff).toFixed(0)}%
                                                                                {!isZero && (percentDiff > 0 ? '↑' : '↓')}
                                                                            </span>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <span>-</span>
                                                                )}
                                                                <span className="mobile-competitor-provider">{displayProvider}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                                    <ColAtm className="inventory-box">
                                        <ColAtm className="inventory-room-box">
                                            <ColAtm xs={3} lg={4} className="align-self-center">
                                                <BlockAtm md={1} className="m-h-auto">
                                                </BlockAtm>
                                                <BlockAtm xs={6}>
                                                    <LabelAtm labelClass="inventory-room-name"
                                                        text={t('enw-cpa_price-title')} />
                                                </BlockAtm>
                                                <Grid item xs={4} />
                                            </ColAtm>
                                            <ColAtm xs={7} className="inventory-date-padding pos-relative" />
                                            <ColAtm xs={1} className="competitor-excel">
                                            {/* {
                                                <>
                                                    <Tooltip title={!changeView ? t('btn-chart_view-title') : t('btn-table_view-title')}>
                                                        <Button type="button"
                                                            onClick={onChangeView}
                                                            variant="contained"
                                                            color="primary"
                                                            style={{height: 35}}
                                                            className="competitior-change-view"
                                                        >
                                                            <i className={!changeView ? "fas fa-chart-line fs-16" : "fas fa-table fs-16"}></i>
                                                        </Button>
                                                    </Tooltip>
                                                </>
                                            } */}
                                            </ColAtm>
                                        </ColAtm>
                                        {/* {
                                        changeView ? (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "100%",
                                                    margin: "16px auto 16px auto",
                                                    marginBottom : 0,
                                                    marginTop: 0,
                                                    padding: "20px",
                                                    position: "relative",
                                                    zoom: window.innerWidth >= 960 && window.innerWidth <= 1600 ? 1.2 : 1,
                                                    overflow: "auto",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <div style={{width: "100%", padding:16}}>
                                                    <Line
                                                        data={getChartData()}
                                                        options={chartOptions}
                                                        height={340}
                                                    />
                                                </div>
                                            </div>
                                        ) :  */}

                                        {currentPropertyInfo &&
                                            <>
                                                <ColAtm className="inventory-avail-box m-h-33" style={{ height: openedHotelKey !== currentPropertyInfo?.key ? (props?.trigger > 0 ? "70px" : "43px") : {}}} key={currentPropertyInfo?.key}>
                                                    <ColAtm xs={2}>
                                                        <Grid item md={1}></Grid>
                                                        <Grid item md={1}>
                                                        </Grid>
                                                        <Grid item md={10}>
                                                            <LabelAtm labelClass="inventory-room-name" style={{display: 'inline-block', width: "300px"}} text={currentPropertyInfo?.name} />
                                                            {
                                                                props?.trigger > 0 &&
                                                                <>
                                                                    <LabelAtm labelClass="inventory-room-name fw-400" style={{display: 'block', marginTop: 5}} text={t('enw-cpa-percentage_difference')} />
                                                                    <LabelAtm labelClass="inventory-room-name fw-400" style={{display: 'block', marginTop: 5}} text={t('enw-cpa-average_competior_price')} />
                                                                </>
                                                            }
                                                        </Grid>
                                                        <BlockAtm className="channels-box" md={2}></BlockAtm>
                                                        <BlockAtm className="inventory-copy-box" md={3}></BlockAtm>
                                                    </ColAtm>
                                                    <ColAtm xs={10}>
                                                        <Grid container className="inventory-rate-price">
                                                            <ColAtm xs={2} />
                                                            <Grid xs={10} className="m-overflow-inventory-price">
                                                                <ColAtm className="inventory-price-padding" style={{marginBottom: "15px"}}>
                                                                    {lsAllDays.map((date) => {
                                                                        const key = `${currentPropertyInfo?.key}_${date}`;
                                                                        const priceObj = currentPropertyPrices[key];
                                                                        
                                                                        // Rakiplerin fiyatlarını selectedProvider'a göre hesapla
                                                                        const competitorPricesForDay = (filteredCpa || [])
                                                                            .map(hotel => {
                                                                                const hotelKey = `${hotel.key}_${date}`;
                                                                                const hotelPriceObj = prices[hotelKey];
                                                                                
                                                                                if (!hotelPriceObj) return null;
                                                                                
                                                                                if (selectedProvider) {
                                                                                    if (hotelPriceObj.provider && hotelPriceObj.provider.trim().toLowerCase() === selectedProvider.toLowerCase()) {
                                                                                        return hotelPriceObj.amount;
                                                                                    }
                                                                                    if (Array.isArray(hotelPriceObj.all)) {
                                                                                        const found = hotelPriceObj.all.find(
                                                                                            item => item.provider && item.provider.trim().toLowerCase() === selectedProvider.toLowerCase()
                                                                                        );
                                                                                        if (found && typeof found.amount === 'number') {
                                                                                            return found.amount;
                                                                                        }
                                                                                    }
                                                                                    return null;
                                                                                }
                                                                                
                                                                                return hotelPriceObj.amount;
                                                                            })
                                                                            .filter(p => typeof p === 'number' && !isNaN(p) && p > 0);
                                                                        
                                                                        const competitorAmounts = (filteredCpa || [])
                                                                            .map(hotel => {
                                                                                const hotelKey = `${hotel.key}_${date}`;
                                                                                const hotelPriceObj = prices[hotelKey];
                                                                                return (hotelPriceObj && typeof hotelPriceObj.amount === 'number') ? hotelPriceObj.amount : null;
                                                                            })
                                                                            .filter(a => a !== null && !isNaN(a));
                                                                        
                                                                        const avgCompetitorAmount = competitorAmounts.length > 0
                                                                        ? competitorAmounts.reduce((a, b) => a + b, 0) / competitorAmounts.length
                                                                        : null;

                                                                        // Rakiplerin ortalaması
                                                                        const avgCompetitorPrice = competitorPricesForDay.length > 0
                                                                            ? competitorPricesForDay.reduce((a, b) => a + b, 0) / competitorPricesForDay.length
                                                                            : null;

                                                                        // Yüzde farkı hesaplama
                                                                        let percentDiff = null;
                                                                        if (priceObj && typeof priceObj.amount === 'number' && priceObj.amount > 0 && avgCompetitorPrice !== null && avgCompetitorPrice > 0) {
                                                                            percentDiff = ((priceObj?.amount - avgCompetitorPrice) / avgCompetitorPrice) * 100;
                                                                        }
                                                                        const isZero = Math.abs(percentDiff) < 0.5;

                                                                        return (
                                                                            <BlockAtm
                                                                                key={key}
                                                                                style={{marginTop:"0px", marginBottom: '15px'}}
                                                                                className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price current-property-block-desktop t-center f-w-600 circle-competitor`}
                                                                            >
                                                                                {priceObj ? (
                                                                                    <>
                                                                                        <span style={{zIndex: 1}}>{priceObj?.amount === 0 ? '-' : priceObj?.amount}</span>
                                                                                        {percentDiff !== null && !isNaN(percentDiff) && (
                                                                                            <span
                                                                                                style={{
                                                                                                    display: 'block',
                                                                                                    fontSize: '12px',
                                                                                                    fontWeight: 500,
                                                                                                    color: isZero ? '#757575' : (percentDiff > 0 ? '#388e3c' : '#d32f2f'), 
                                                                                                    // marginTop: 2,
                                                                                                    lineHeight: 1,
                                                                                                    textAlign: 'center',
                                                                                                    marginLeft: 15,
                                                                                                    marginTop: 10
                                                                                                }}
                                                                                            >
                                                                                                {Math.abs(percentDiff).toFixed(0)}%
                                                                                                {!isZero && (percentDiff > 0 ? '↑' : '↓')}
                                                                                            </span>
                                                                                        )}
                                                                                        {/* Rakip amount ortalaması */}
                                                                                        {avgCompetitorAmount !== null && (
                                                                                            <>
                                                                                                <span
                                                                                                    style={{
                                                                                                        display: 'block',
                                                                                                        fontSize: '12px',
                                                                                                        fontWeight: 500,
                                                                                                        color: '#666',
                                                                                                        // marginTop: 2,
                                                                                                        lineHeight: 1,
                                                                                                        textAlign: 'center',
                                                                                                        marginLeft: 12,
                                                                                                        marginTop: 10
                                                                                                    }}
                                                                                                >
                                                                                                    {formatAmountWithDot(Number(avgCompetitorAmount.toFixed(1)))}
                                                                                                </span>
                                                                                                <style>
                                                                                                    {`
                                                                                                        .current-property-divider {
                                                                                                            margin-top:18px!important;
                                                                                                        }
                                                                                                    `}
                                                                                                </style>
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <span>-</span>
                                                                                )}
                                                                                <p className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-radius-cpa'} null-inventory`}> &nbsp;</p>
                                                                            </BlockAtm>
                                                                        );
                                                                    })}
                                                                    <p className="inventory-currency">{currency ?? getCurrency()}</p>
                                                                </ColAtm>
                                                            </Grid>
                                                        </Grid>
                                                    </ColAtm>
                                                </ColAtm>
                                                { window.innerWidth > 768 && <Divider className="current-property-divider" style={{width: "92.5%", display: "flex", margin: "0 auto"}} /> }
                                            </>
                                        }
                                        {filteredCpa?.map((hotel) =>
                                            <ColAtm className="inventory-avail-box m-h-33" style={openedHotelKey !== hotel.key ? { height: "43px" } : {}} key={hotel.key}>
                                                <ColAtm xs={2}>
                                                    <Grid item md={1}></Grid>
                                                    <Grid item md={1}>
                                                        <Button
                                                            size="small"
                                                            style={{
                                                                minWidth: 24,
                                                                height: 24,
                                                                padding: 0,
                                                                marginLeft: '-8px',
                                                                marginTop: '-1px',
                                                                borderRadius: "50%",
                                                                background: "#e3f2fd",
                                                                color: "#1976d2",
                                                                fontWeight: "bold",
                                                                fontSize: 18,
                                                                lineHeight: 1,
                                                            }}
                                                            onClick={() => setOpenedHotelKey(openedHotelKey === hotel.key ? null : hotel.key)}
                                                            disabled={Object.keys(prices).length > 0 ? false : true}
                                                            aria-label="Add"
                                                            >
                                                            {openedHotelKey === hotel.key ? '-' : '+'}
                                                        </Button>
                                                    </Grid>
                                                    <Grid item md={10}>
                                                        <LabelAtm labelClass="inventory-room-name" style={{display: 'inline-block', width: "300px"}} text={hotel?.name} />
                                                           
                                                            {openedHotelKey === hotel.key && (
                                                                <>
                                                                {(() => {
                                                                    let providerSet = new Map();
                                                                    
                                                                    lsAllDays.forEach(date => {
                                                                        const key = `${hotel.key}_${date}`;
                                                                        const priceObj = prices[key];
                                                                        if (Array.isArray(priceObj?.all)) {
                                                                            priceObj.all.forEach(p => {
                                                                                if (p.provider && p.amount !== undefined && p.amount !== null) {
                                                                                    if (!providerSet.has(p.provider)) {
                                                                                        providerSet.set(p.provider, { 
                                                                                            provider: p.provider, 
                                                                                            logo: p.logo || '',
                                                                                            hasData: true
                                                                                        });
                                                                                    }
                                                                                }
                                                                            });
                                                                        }
                                                                    });

                                                                    let providerObjs = Array.from(providerSet.values());
                                                                    const firstDate = lsAllDays[0];
                                                                    const firstKey = `${hotel.key}_${firstDate}`;
                                                                    const firstPriceObj = prices[firstKey];
                                                                    
                                                                    providerObjs.sort((a, b) => {
                                                                        let amountA = Number.MAX_SAFE_INTEGER;
                                                                        let amountB = Number.MAX_SAFE_INTEGER;
                                                                        
                                                                        if (Array.isArray(firstPriceObj?.all)) {
                                                                            const foundA = firstPriceObj.all.find(p => p.provider === a.provider);
                                                                            const foundB = firstPriceObj.all.find(p => p.provider === b.provider);
                                                                            if (foundA && typeof foundA.amount === "number") amountA = foundA.amount;
                                                                            if (foundB && typeof foundB.amount === "number") amountB = foundB.amount;
                                                                        }
                                                                        
                                                                        return amountA - amountB;
                                                                    });

                                                                    return providerObjs;
                                                                })().map((provider, idx) => (
                                                                    <div
                                                                        key={idx}
                                                                        style={{
                                                                            // background: idx % 2 === 0 ? '#f5faff' : undefined,
                                                                            // borderRadius: idx % 2 === 0 ? '8px' : undefined,
                                                                            // padding: idx % 2 === 0 ? '8px 0' : undefined,
                                                                            marginTop: '26px',
                                                                            marginBottom: '26px',
                                                                        }}
                                                                    >
                                                                        <div className="cpa-border" style={{
                                                                            position: "absolute",
                                                                            width: 1590,
                                                                            borderRadius: "8px",
                                                                            height: 55,
                                                                            background: idx % 2 === 0 ? '#f5faff' : undefined,
                                                                        }}></div>
                                                                        <LabelAtm
                                                                            labelClass="inventory-room-name"
                                                                            style={{padding: "2px 0", fontSize: 14, marginLeft: 5, paddingTop: "0px", marginBottom: 0, background: 'transparent', position: "relative", zIndex: 2}}
                                                                            text={
                                                                                <>
                                                                                    <img 
                                                                                        src={provider?.logo ?? ''}
                                                                                        alt="Provider Logo"
                                                                                        style={{width: "100px", height: "50px", maxWidth: '100px', maxHeight: '50px', marginLeft: 20, verticalAlign: 'middle'}}
                                                                                    />
                                                                                    {/* {provider?.provider} */}
                                                                                </>
                                                                            }
                                                                        />
                                                                        
                                                                    </div>
                                                                ))}
                                                                </>
                                                            )}
                                                    </Grid>
                                                    <BlockAtm className="channels-box" md={2}></BlockAtm>
                                                    <BlockAtm className="inventory-copy-box" md={3}></BlockAtm>
                                                </ColAtm>
                                                <ColAtm xs={10}>
                                                    <Grid container className="inventory-rate-price">
                                                        <ColAtm xs={2} />
                                                        <Grid xs={10} className="m-overflow-inventory-price">
                                                            <ColAtm className="inventory-price-padding" style={{marginBottom: "15px"}}>
                                                            {
                                                                lsAllDays.map((date) => {
                                                                    const key = `${hotel.key}_${date}`;
                                                                    const priceObj = prices[key];
                                                                    const selected = selectedProvider;
                                                                    let showPrice = false;
                                                                    let displayAmount = "-";
                                                                    let displayProvider = "-";

                                                                    if (!selected) {
                                                                        showPrice = true;
                                                                        if (priceObj) {
                                                                            displayAmount = priceObj.amount ?? "-";
                                                                            displayProvider = priceObj.provider ?? "-";
                                                                        }
                                                                    } else if (priceObj) {
                                                                        if (priceObj.provider && priceObj.provider.trim().toLowerCase() === selected) {
                                                                            showPrice = true;
                                                                            displayAmount = priceObj.amount ?? "-";
                                                                            displayProvider = priceObj.provider ?? "-";
                                                                        } else if (Array.isArray(priceObj.all)) {
                                                                            const found = priceObj.all.find(
                                                                                item => item.provider && item.provider.trim().toLowerCase() === selected
                                                                            );
                                                                            if (found) {
                                                                                showPrice = true;
                                                                                displayAmount = found.amount ?? "-";
                                                                                displayProvider = found.provider ?? "-";
                                                                            }
                                                                        }
                                                                    }
                                                                    // Diğer rakip otellerin fiyatları (kendi otel ve mevcut otel hariç)
                                                                    const allOtherPrices = [];
                                                                    (filteredCpa || []).forEach(otherHotel => {
                                                                        if (otherHotel.key !== hotel.key) {
                                                                            const otherKey = `${otherHotel.key}_${date}`;
                                                                            const otherPrice = prices[otherKey]?.amount;
                                                                            if (typeof otherPrice === 'number' && !isNaN(otherPrice) && otherPrice > 0) {
                                                                                allOtherPrices.push(otherPrice);
                                                                            }
                                                                        }
                                                                    });
                                                                    
                                                                    // Diğerlerinin ortalaması
                                                                    const avgOtherPrice = allOtherPrices.length > 0
                                                                        ? allOtherPrices.reduce((a, b) => a + b, 0) / allOtherPrices.length
                                                                        : null;
                                                                    
                                                                    // Yüzde farkı
                                                                    let percentDiff = null;
                                                                    const currentAmount = typeof displayAmount === 'number' ? displayAmount : null;
                                                                    if (currentAmount !== null && currentAmount > 0 && avgOtherPrice !== null && avgOtherPrice > 0) {
                                                                        percentDiff = ((currentAmount - avgOtherPrice) / avgOtherPrice) * 100;
                                                                    }
                                                                    const isZero = Math.abs(percentDiff) < 0.5;

                                                                    return (
                                                                        <BlockAtm
                                                                            key={key}
                                                                            style={{marginTop:"0px", marginBottom: '15px'}}
                                                                            className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`}
                                                                        >
                                                                            {loading[key] ? (
                                                                                <CircularProgress
                                                                                    className='circularProgress-report'
                                                                                    style={{
                                                                                        color: "#d71f26",
                                                                                        zIndex: "99"
                                                                                    }}
                                                                                    size={16}
                                                                                />
                                                                            ) : error[key] ? (
                                                                            <span style={{height: "auto", width: "auto"}}>-</span>
                                                                            ) : showPrice ? (
                                                                                <Tooltip
                                                                                    PopperProps={{ disablePortal: true }}
                                                                                    title={displayProvider}
                                                                                >
                                                                                    <div
                                                                                        id={key}
                                                                                        onClick={e => openModal(e, key)}
                                                                                        className="MuiFormControl-root MuiTextField-root type-number-hidden MuiFormControl-fullWidth"
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    >
                                                                                        <span style={{height: "auto", width: "auto"}}>{formatAmountWithDot(displayAmount)}</span>
                                                                                        {percentDiff !== null && !isNaN(percentDiff) && (
                                                                                            <span
                                                                                                style={{
                                                                                                    display: 'block',
                                                                                                    fontSize: '12px',
                                                                                                    fontWeight: 500,
                                                                                                    color: isZero ? '#757575' : (percentDiff > 0 ? '#388e3c' : '#d32f2f'),
                                                                                                    marginTop: 3,
                                                                                                    lineHeight: 1,
                                                                                                    textAlign: 'center',
                                                                                                    marginLeft: 15
                                                                                                }}
                                                                                            >
                                                                                                {Math.abs(percentDiff).toFixed(0)}%
                                                                                                {!isZero && (percentDiff > 0 ? '↑' : '↓')}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : (
                                                                                <div>-</div>
                                                                            )}

                                                                            <p className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-radius-cpa'} null-inventory`}> &nbsp;</p>
                                                                        </BlockAtm>
                                                                    );
                                                                })
                                                            }
                                                            <p className="inventory-currency">{currency ?? getCurrency()}</p>
                                                        </ColAtm>
                                                        {openedHotelKey === hotel.key && (
                                                            <div style={{marginTop: "-19px"}}>
                                                                <style>{`
                                                                    .weekend-radius-cpa {
                                                                        height:0px;
                                                                    }
                                                                `}</style>
                                                                {(() => {
                                                                    let providerSet = new Map();
                                                                    
                                                                    lsAllDays.forEach(date => {
                                                                        const key = `${hotel.key}_${date}`;
                                                                        const priceObj = prices[key];
                                                                        if (Array.isArray(priceObj?.all)) {
                                                                            priceObj.all.forEach(p => {
                                                                                if (p.provider && p.amount !== undefined && p.amount !== null) {
                                                                                    if (!providerSet.has(p.provider)) {
                                                                                        providerSet.set(p.provider, { 
                                                                                            provider: p.provider, 
                                                                                            logo: p.logo || '',
                                                                                            hasData: true
                                                                                        });
                                                                                    }
                                                                                }
                                                                            });
                                                                        }
                                                                    });

                                                                    let providerObjs = Array.from(providerSet.values());
                                                                    const firstDate = lsAllDays[0];
                                                                    const firstKey = `${hotel.key}_${firstDate}`;
                                                                    const firstPriceObj = prices[firstKey];
                                                                    
                                                                    providerObjs.sort((a, b) => {
                                                                        let amountA = Number.MAX_SAFE_INTEGER;
                                                                        let amountB = Number.MAX_SAFE_INTEGER;
                                                                        
                                                                        if (Array.isArray(firstPriceObj?.all)) {
                                                                            const foundA = firstPriceObj.all.find(p => p.provider === a.provider);
                                                                            const foundB = firstPriceObj.all.find(p => p.provider === b.provider);
                                                                            if (foundA && typeof foundA.amount === "number") amountA = foundA.amount;
                                                                            if (foundB && typeof foundB.amount === "number") amountB = foundB.amount;
                                                                        }
                                                                        
                                                                        return amountA - amountB;
                                                                    });

                                                                    return (
                                                                        <div>
                                                                           {providerObjs.map((providerObj, pIdx) => (
                                                                                <div
                                                                                    key={`provider-row-${providerObj.provider}-${pIdx}`}
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        marginBottom: "57px",
                                                                                    }}
                                                                                    className="inventory-price-padding"
                                                                                >
                                                                                    {lsAllDays.map((date, dIdx) => {
                                                                                        const key = `${hotel.key}_${date}`;
                                                                                        const priceObj = prices[key];
                                                                                        let amount = "-";
                                                                                        let hasProviderData = false;

                                                                                        if (Array.isArray(priceObj?.all)) {
                                                                                            const found = priceObj.all.find(p => p.provider === providerObj.provider);
                                                                                            if (found && found.amount !== undefined && found.amount !== null) {
                                                                                                amount = found.amount;
                                                                                                hasProviderData = true;
                                                                                            }
                                                                                        }

                                                                                        return (
                                                                                            <BlockAtm
                                                                                                key={`${providerObj.provider}-${date}-${dIdx}`}
                                                                                                className={`${(moment(date).locale('de').weekday() == 5 || moment(date).locale('de').weekday() == 6) && 'weekend-inputs'} inventory-price t-center f-w-600 circle-competitor`}
                                                                                                style={{minWidth: 60}}
                                                                                            >
                                                                                                {loading[key] ? (
                                                                                                    <CircularProgress
                                                                                                        className='circularProgress-report'
                                                                                                        style={{
                                                                                                            color: "#d71f26",
                                                                                                            zIndex: "99"
                                                                                                        }}
                                                                                                        size={16}
                                                                                                    />
                                                                                                ) : error[key] ? (
                                                                                                    <span style={{height: "auto", width: "auto"}}>-</span>
                                                                                                ) : hasProviderData ? (
                                                                                                    <Tooltip
                                                                                                        PopperProps={{ disablePortal: true }}
                                                                                                        title={providerObj.provider}
                                                                                                    >
                                                                                                        <div
                                                                                                            id={`${providerObj.provider}-${date}`}
                                                                                                            onClick={e => openModal(e, key, providerObj.provider)}
                                                                                                            className="MuiFormControl-root MuiTextField-root type-number-hidden MuiFormControl-fullWidth"
                                                                                                            style={{ cursor: 'pointer' }}
                                                                                                        >
                                                                                                            <span style={{height: "auto", width: "auto", display: 'inline-block'}}>{formatAmountWithDot(amount)}</span>
                                                                                                        </div>
                                                                                                    </Tooltip>
                                                                                                ) : <div>-</div>
                                                                                                }
                                                                                            </BlockAtm>
                                                                                        );
                                                                                    })}
                                                                                    <p className="inventory-currency" style={{marginTop: "0px"}}>{currency ?? getCurrency()}</p>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    );
                                                                })()}
                                                            </div>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </ColAtm>
                                            </ColAtm>
                                        )}
                                    </ColAtm>
                                    <Grid container spacing={3} style={{marginTop: 12}} className="competitor-chart-container">
                                        <Grid item md={4} xs={12}>
                                            <div className={filteredCpa.length > 1 ? "competitor-chart-div cpa-average-table-align-normal" : "competitor-chart-div cpa-average-table-align-baseline"} style={{height: '100%', minHeight: 400, padding: 30}}>
                                                <table className="cpa-modal-table">
                                                    <thead>
                                                        <tr className="cpa-modal-table-header">
                                                            <th colSpan={2} className="cpa-modal-table-header-cell">
                                                                {t('enw-cpa-average_prices')}
                                                            </th>
                                                        </tr>
                                                        <tr className="cpa-modal-table-titles">
                                                            <th className="cpa-modal-table-th provider">{t('property_type-hotel')}</th>
                                                            <th className="cpa-modal-table-th amount">{t('enw-input-price')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {hotelAmounts.map((hotel, idx) => (
                                                            <tr key={idx} className="cpa-modal-table-row cpa-average-table-tr">
                                                                <td className="cpa-modal-table-td provider">
                                                                    {idx + 1}{". "}{hotel?.name}
                                                                </td>
                                                                <td className="cpa-modal-table-td amount">
                                                                    {!hotel?.total ? '-' : formatAmountWithDot(hotel.total) + ' ' + currency ?? getCurrency()}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Grid>
                                            <Grid item md={8} xs={12}>
                                                <div className="competitor-chart-div" style={{
                                                    height: '100%',
                                                    minHeight: 400, 
                                                    padding: 30, 
                                                    zoom: window.innerWidth >= 960 && window.innerWidth <= 1600 ? 1.2 : 1
                                                    }}
                                                >
                                                    <Line
                                                        data={getChartData()}
                                                        options={chartOptions}
                                                        height={350}
                                                    />
                                                </div>
                                        </Grid>
                                    </Grid>
                                    <style>{`
                                        @media screen and (max-width: 768px) {
                                            .inventory-box { 
                                                display: none !important; 
                                            }
                                        }
                                        @media (min-width: 1023px) and (max-width: 1533px) {
                                            .cpa-border {
                                                width: 1420px !important;
                                            }
                                        }
                                        @media (min-width: 1980px) and (max-width: 2490px) {
                                            .cpa-border {
                                                width: 1610px !important;
                                            }
                                        }
                                        .MuiDialog-paperWidthXs {
                                            max-width:700px!important;
                                        }
                                        .inventory-price span {
                                            position:relative!important
                                        }
                                        .MuiSelect-select:focus {
                                            background-color:#fff!important
                                        }
                                        @media screen and (max-width: 768px) {
                                            .MuiDialog-paperFullWidth {
                                                width:100% !important;
                                            }
                                        }
                                        .inventory-rate-price {
                                            align-items:baseline!important;
                                        }
                                        .weekend-radius-cpa {
                                            margin-top:-97px;
                                        }
                                        @media screen and (min-width: 768px) {
                                            .inventory-currency {
                                                top: 0 !important; 
                                            }
                                        }
                                    `}</style>
                                    <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="xs" fullWidth>
                                        <DialogTitle>
                                            {t('enw-input-provider_prices-title')}
                                            <IconButton
                                                aria-label="close"
                                                onClick={() => setModalOpen(false)}
                                                style={{ position: 'absolute', right: 8, top: 8 }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </DialogTitle>
                                        {/* Modal İçi */}
                                        <DialogContent dividers>
                                            {filteredModalList.length > 0 ? (
                                                <table className="cpa-modal-table">
                                                    <thead>
                                                        <tr className="cpa-modal-table-header">
                                                            <td colSpan={2} className="cpa-modal-table-header-cell">
                                                                {"1. "} {modalProvider} - {modalAmount} {modalCurrency}
                                                            </td>
                                                        </tr>
                                                        <tr className="cpa-modal-table-titles">
                                                            <th className="cpa-modal-table-th provider">{t('enw-input-provider')}</th>
                                                            <th className="cpa-modal-table-th amount">{t('enw-input-price')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredModalList.map((item, idx) => {
                                                            const isSelected = selectedProvider && item.provider && item.provider.trim().toLowerCase() === selectedProvider;
                                                            return (
                                                                <tr
                                                                    key={idx}
                                                                    className={
                                                                        "cpa-modal-table-row" +
                                                                        (item.provider === modalProvider  ? " d-none" : item.provider.trim().toLowerCase() === subProviders.trim().toLowerCase() ? " selected" : "") +
                                                                        (isSelected ? " filtered-provider-row" : "")
                                                                    }
                                                                >
                                                                    <td
                                                                        className={
                                                                            "cpa-modal-table-td provider" +
                                                                            (isSelected ? " filtered-provider-td" : "")
                                                                        }
                                                                        style={isSelected ? { background: "#e3f2fd" } : {}}
                                                                    >
                                                                        {idx + 1 + ". "}{item.provider}
                                                                    </td>
                                                                    <td className="cpa-modal-table-td amount">
                                                                        {formatAmountWithDot(item.amount)} <span className="cpa-modal-table-currency">{item.currencyCode}</span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div style={{ fontSize: "16px", fontWeight: "500" }}>{t('enw-cpa-data_not_found')}</div>
                                            )}
                                        </DialogContent>
                                        <DialogActions>
                                            <ButtonAtm
                                                className="m-auto cpa-modal-close-btn bg-red"
                                                buttontext={t('btn-close')}
                                                onClick={() => setModalOpen(false)}
                                                autoFocus
                                                color="primary"
                                            />
                                        </DialogActions>
                                    </Dialog>
                                </>
                                :
                                <></>
                        }
                    </>
            }
        </>
    )
}

export default CompetitorAnalysis;